import React from 'react';
import { useParams } from 'react-router-dom';
import { projectList } from '../utils/ProjectList';
import '../styles/ProjectDisplay.css';

function ProjectDisplay(props) {
    const {id} = useParams();
    const project = projectList[id];
    return (
        <div className = "project">
           <h1>{project.name}</h1>    
          <a href={project.conn}> <img src={project.image} alt=""/>   </a>
           <p>
            <b>Skills : </b>{project.skills}
           </p>
           
        </div>
    );
}

export default ProjectDisplay;